import { DEFAULT_PAGE_SIZE } from '@/constants';
import { EmploymentStatus, ListResponse } from '@/types/common';
import { StaffInfo } from '@/types/staff';
import { requestWrapper } from '@/utils/request';
import { ClueAutoAssignSwitch } from '@/types/clue';

// 创建员工需要的参数
export interface CreateStaffParams {
  id?: number; // 员工 ID
  avatar: string; // 头像链接
  username: string; // 用户名
  mobile: string; // 手机号
  status: EmploymentStatus; // 状态：1 表示在职，2 表示离职
  nickname?: string; // 昵称
  role_id: number; // 角色 ID
  store_id_arr: number[]; // 所属店铺 ID
  store_admin_settings?: {
    store_id: number;
    is_leads_auto_assign: ClueAutoAssignSwitch;
  }[];
}

// 创建员工
export async function createStaff(body: CreateStaffParams) {
  return requestWrapper<StaffInfo>('/api/admin/create', {
    method: 'POST',
    data: body,
  });
}

// 更新员工信息
export async function updateStaff(body: CreateStaffParams) {
  return requestWrapper<StaffInfo>('/api/admin/update', {
    method: 'POST',
    data: body,
  });
}

// 获取员工列表
export async function getStaffList(
  params: {
    ids?: string; // 员工 ID 列表(字符串，如: '1,2,3')
    store_id?: number;
    mobile?: string;
    status?: number; // 0：全部，1：在职，2：离职
    page?: number;
    page_size?: number;
  } = {},
) {
  const defaultParams = {
    status: EmploymentStatus.EMPLOYED, // 默认查询在职员工
    page: 1,
    page_size: DEFAULT_PAGE_SIZE,
  };

  const mergedParams = {
    ...defaultParams,
    ...params,
  };

  return requestWrapper<ListResponse<StaffInfo>>('/api/admin/list', {
    method: 'GET',
    params: mergedParams,
  });
}
